// EQG-MOB-03 §4 — offline work-order sign-off queue. Signing off with no signal
// is a success: the completion is stored locally and flushed when signal returns.
import { mobileApi } from './api';

const KEY = 'mobile_wo_complete_queue';
const EVENT = 'woqueuechange';

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};
const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVENT));
};

export const woQueueCount = () => read().length;

export const enqueueWoComplete = (woId, payload) => {
  const list = read();
  list.push({ woId, payload, queued_at: new Date().toISOString() });
  write(list);
  return list.length;
};

let flushing = false;
export const flushWoQueue = async (token) => {
  if (flushing || !navigator.onLine) return;
  const list = read();
  if (list.length === 0) return;
  flushing = true;
  const remaining = [];
  for (const item of list) {
    try { await mobileApi.completeWorkOrder(item.woId, item.payload, token); }
    catch { remaining.push(item); }
  }
  write(remaining);
  flushing = false;
};

export const onWoQueueChange = (cb) => {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
};
